import { gql } from '@apollo/client';
import paginated from '../client/pagination';
import { createStringVariables } from './utils';
export const QUOTATION_FIELDS = `
  currency
  premium_frequency
  basic_premium
  non_insurance_premium
  premium_loading
  premium_loadings
  discount
  discount_config
  levy
  total_premium
  pre_levy_premium
`;
const PROJECTION_FIELDS = `
  application
  quotations
  product
  currency
  premium_frequency
`;
const retrieveProjectionsVariables = createStringVariables(['application_case_id', 'application_id']);
export const RETRIEVE_PROJECTIONS = gql`
  query Projections(
    ${retrieveProjectionsVariables.variableTypes}
    $projection_years: Int!
  ) {
    projections(
      ${retrieveProjectionsVariables.variables}
      projection_years: $projection_years
    )
      @rest(type: "[Projection]" path: "/premium-projection?{args}"){
      __typename
      ${PROJECTION_FIELDS}
    }
  }
`;
const retrieveQuotationStringVariables = createStringVariables(['role', 'age', 'gender', 'smoker', 'currency', 'frequency', 'date_of_birth', 'coupon_code']);
export const RETRIEVE_QUOTATION = gql`
  query Quotation(
    $product_id: String!,
    $sum_assured: Int,
    $age: Int,
    ${retrieveQuotationStringVariables.variableTypes}
  ) {
    quotation(
      product_id: $product_id,
      sum_assured: $sum_assured,
      age: $age,
      ${retrieveQuotationStringVariables.variables}
    )
    @rest(type: "Quotation", path: "/quotation?{args}") {
      __typename
      ${QUOTATION_FIELDS}
    }
  }
`;
export const ESTIMATE_GROUP_QUOTE = gql`
  query GroupQuoteEstimates($input: GroupQuoteEstimateInput!) {
    groupQuoteEstimates(input: $input)
      @rest(
        type: "[GroupQuoteEstimate]"
        path: "/group-quotation/estimation"
        method: "POST"
      ) {
      __typename
      product_code
      currency
      monthly_premium
    }
  }
`;
export const RETRIEVE_BULK_QUOTATION = gql`
  query BulkQuotations(
    $products: String!
    $age: Int,
    ${retrieveQuotationStringVariables.variableTypes}
  ) {
    bulkQuotations(
      products: $products
      age: $age,
      ${retrieveQuotationStringVariables.variables}
    ) @rest(type: "[BulkQuotation]", path: "/quotation/bulk?{args}") {
      __typename
      product
      quotation
    }
  }
`;
export const RETRIEVE_DEFAULT_COUPON_MAPPING = gql`
  query DefaultCouponMapping($type: String!) {
    defaultCouponMapping(type: $type)
      @rest(
        type: "DefaultCouponMapping"
        path: "/default-coupon-mapping/{args.type}"
      ) {
      id
      type
      coupon_code
      effective_from
      effective_to
      create_date
      update_date
      __typename
    }
  }
`;
const listDefaultCouponMappingVariables = createStringVariables(['type_code', 'coupon_code', 'ordering', 'no_pagination', 'page', 'page_size']);
export const LIST_DEFAULT_COUPON_MAPPING = paginated(gql`
  query DefaultCouponMappings(${listDefaultCouponMappingVariables.variableTypes}) {
    defaultCouponMappings(${listDefaultCouponMappingVariables.variables})
      @rest(
        type: "DefaultCouponMapping"
        path: "/default-coupon-mapping?{args}"
      ) {
      id
      type
      coupon_code
      effective_from
      effective_to
      create_date
      update_date
      __typename
    }
  }
`);
export const RETRIEVE_BULK_PRODUCT_PREMIUM_PROJECTIONS = gql`
  query ProductPremiumProjections(
    $products: String!
    $projection_years: Int!
    ${retrieveQuotationStringVariables.variableTypes}
  ) {
    productPremiumProjections(
      products: $products
      projection_years: $projection_years
      ${retrieveQuotationStringVariables.variables}
    )
      @rest(type: "[ProductPremiumProjection]", path: "/projection/bulk?{args}") {
      __typename
      product
      projection
    }
  }
`;